// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__fbudt","socialContainer":"Footer_socialContainer__AiTkI","list":"Footer_list__Fy566","link":"Footer_link__c9NPA","col4":"Footer_col4__9I03a"};